// Text-to-speech client for the Research Academia TTS endpoint.
// The TTS service is hosted on the root domain (not the pod subdomain),
// so it uses its own base URL, overridable via REACT_APP_TTS_BASE.

const TTS_BASE = process.env.REACT_APP_TTS_BASE || '';

// Decode a base64 string into a Blob of the given MIME type.
function base64ToBlob(base64, mime) {
  const byteChars = atob(base64);
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    bytes[i] = byteChars.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
}

// Cache synthesized audio object URLs by text so repeat plays are instant
// and don't re-hit the server.
const urlCache = new Map();

// Synthesize speech for the given text and return a playable object URL.
export async function synthesizeSpeech(text) {
  const key = (text || '').trim();
  if (!key) throw new Error('Nothing to speak');
  if (urlCache.has(key)) return urlCache.get(key);

  const res = await fetch(`${TTS_BASE}/api/tts/synthesize`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text: key }),
  });

  if (!res.ok) throw new Error(`TTS request failed (${res.status})`);

  const json = await res.json();
  if (!json.audio) throw new Error(json.error || 'No audio returned');

  const format = json.format || 'mp3';
  const mime = format === 'mp3' ? 'audio/mpeg' : `audio/${format}`;
  const url = URL.createObjectURL(base64ToBlob(json.audio, mime));
  urlCache.set(key, url);
  return url;
}
